import "./style.scss";
import { FC, Fragment } from "react";
import { IUniversityPrograms } from "@/src/types/IUniversityPrograms";
import UniversityProgramsCardDesk from "../UniversityProgramsCardDesk/UniversityProgramsCardDesk";
import UniversityProgramsSlider from "../UniversityProgramsSliderDesk/UniversityProgramsSliderDesk";

interface IContent {
  content: IUniversityPrograms[];
  universityCardName: string;
  setUniversityCardName: (id: string) => void;
}

const UniversityProgramsContentDesk: FC<IContent> = ({ content, universityCardName, setUniversityCardName }) => {
  return (
    <div className="university-programs-content">
      <div className={`university-programs-cards ${content.length > 7 ? "qualification" : ""}`}>
        {content.map((item, index) => (
          <Fragment key={index}>
            <UniversityProgramsCardDesk
              currentTab={content.length > 7 ? "qualification" : "education"}
              name={item.name}
              img={item.img}
              path={item.path}
              universityCardName={universityCardName}
              setUniversityCardName={setUniversityCardName}
            />
          </Fragment>
        ))}
      </div>
      {content.length < 7 &&
        content.map(
          (item, index) =>
            item.name === universityCardName && (
              <Fragment key={index}>
                <UniversityProgramsSlider programs={item.programs} path={item.path} />
              </Fragment>
            )
        )}
    </div>
  );
};

export default UniversityProgramsContentDesk;
